import { createSelector } from 'reselect';

const notificationCenterData = (state) => state.notificationCenterData;

export const selectNotificationCenterTabData = () =>
  createSelector([notificationCenterData], (state) => state.selectedTab);
